import React, { useContext, useMemo } from 'react';

import queryString from 'query-string';

import { getUnifiedCodeLanguageId } from '../../../utils/getUnifiedCodeLanguageId';
import { ContentContext } from '../../context/ContentContext';

interface Props {
  query?: string;
  children: React.ReactNode;
}

export const ContentIf: React.FC<Props> = ({ query, children }) => {
  if (!query) {
    throw new Error(
      'IMGLY - Please provide a query prop to the ContentIf element',
    );
  }

  const { activeItems } = useContext(ContentContext);

  const show = useMemo(() => {
    const params = queryString.parse(query?.toLocaleLowerCase() || '');

    return Object.entries(params).every(
      ([key, value]) =>
        typeof value === 'string' &&
        getUnifiedCodeLanguageId(activeItems[key]) ===
          getUnifiedCodeLanguageId(value),
    );
  }, [query, activeItems]);

  return (show && children) as React.ReactElement;
};
